import { RootState } from '../../store/rootReducersType';

export const getFlagMap = (state: RootState) => state.flags.flagMap;
